export default __webpack_public_path__ + "static/media/betslip-empty3x.2fd3b48f.png";